import { render, staticRenderFns } from "./CopyVersion.vue?vue&type=template&id=1b9e21e0&scoped=true"
import script from "./CopyVersion.vue?vue&type=script&lang=js"
export * from "./CopyVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e21e0",
  null
  
)

export default component.exports